<script>
import _ from 'lodash'
import ListUtils from '@/utils/list'
import OrgService from '@/request/user/org'
import RoleService from '@/request/user/role'
import UserService from '@/request/user/orguser'
import DoctorService from '@/request/record/doctor'
export default {
  name: 'RecordDoctorEdit',
  components: {},
  props: {
    oid: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      orgTreeData: [],
      userPagination: {
        size: 10,
        total: 0,
        current: 1,
        sizes: [10, 20, 30],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
      userLoading: false,
      users: [],
      userOids: [],
      uids: [],
      roleSelection: [],
      role: null
    }
  },
  created: function () {
    this.listOrg()
  },
  watch: {
    oid (newVal, oldVal) {
      if (newVal === oldVal) {
        return
      }
      if (newVal) {
        this.userOids = ListUtils.findIdFromTree(this.orgTreeData, newVal, 'id', 'children')
      } else {
        this.userOids = []
      }
      this.role = null
      this.userPagination.current = 1
      this.listRole()
      this.listUser()
      this.listDoctorUid()
    },
    role () {
      this.listUser()
    }
  },
  methods: {
    listOrg: function () {
      OrgService.listOrg({
        typeSns: 'lx0001,lx0001001,lx0001001001'
      }).then(res => {
        let data = res.result || []
        this.orgTreeData = _.clone(ListUtils.listToTree(data, 'id', 'pid', 'children'))
        if (this.oid && _.isEmpty(this.userOids)) {
          this.userOids = ListUtils.findIdFromTree(this.orgTreeData, this.oid, 'id', 'children')
          this.listRole()
          this.listUser()
          this.listDoctorUid()
        }
      })
    },
    handleUserSizeChange (val) {
      var self = this
      self.userPagination.size = val
      self.listUser()
    },
    handleUserCurrentChange (val) {
      var self = this
      self.userPagination.current = val
      self.listUser()
    },
    listUser () {
      let self = this
      self.users = []
      // if (_.isEmpty(self.userOids)) {
      //   return
      // }
      if (!self.oid) {
        return
      }
      self.userLoading = true
      UserService.find(self.userPagination, {
        // oids: _.join(self.userOids),
        oids: self.oid,
        rids: self.role
      }).then(res => {
        let data = res.result || {}
        self.users = _.clone(data.content || [])
        self.userPagination.total = data.totalElements || 0
        for (let i = 0; i < self.users.length; i++) {
          let user = self.users[i]
          if (_.isEmpty(self.uids)) {
            user.isDoctor = false
          } else {
            user.isDoctor = _.indexOf(self.uids, user.uid) >= 0
          }
          self.$set(self.users, i, user)
        }
      }).finally(() => {
        self.userLoading = false
      })
    },
    listDoctorUid () {
      let self = this
      if (!self.oid) {
        self.uids = []
        return
      }
      DoctorService.listUid({
        oids: self.oid
      }).then(res => {
        self.uids = _.clone(res.result || [])
        if (_.isEmpty(self.users)) {
          return
        }
        for (let i = 0; i < self.users.length; i++) {
          let user = self.users[i]
          user.isDoctor = _.indexOf(self.uids, user.uid) >= 0
          self.$set(self.users, i, user)
        }
      }, () => {
        self.uids = []
      })
    },
    listRole () {
      let self = this
      self.roleSelection = []
      // if (_.isEmpty(self.userOids)) {
      //   return
      // }
      RoleService.listOrgRole({
        // oids: _.join(self.userOids)
        oids: self.oid
      }).then(res => {
        self.roleSelection = _.clone(res.result || [])
      }).catch(() => {
        self.roleSelection = []
      })
    },
    handleAddDoctor (item) {
      if (!item || !this.oid) {
        return
      }
      DoctorService.save({
        oid: this.oid,
        uid: item.uid
      }).then((doctor) => {
        this.listDoctorUid()
        this.$emit('add', doctor)
      }, err => {
        this.$message.error(err)
      })
    },
    handleDeleteDoctor (item) {
      if (!item || !this.oid) {
        return
      }
      let self = this
      self.$confirm('确认从组织中移除医生[' + item.name + ']吗?', '提示', {type: 'warning'}).then(() => {
        DoctorService.delete({
          oid: self.oid,
          uid: item.uid
        }).then(() => {
          this.listDoctorUid()
          this.$emit('delete')
        })
      }, () => {
        self.$message({
          message: '取消删除!',
          type: 'success'
        })
      })
    }
  }
}
</script>

<template>
  <div>
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item>
        <el-select v-model="role" placeholder="选择角色">
          <el-option :key="null" label="全部角色" :value="null"></el-option>
          <el-option v-for="item in roleSelection" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-table
      v-loading.body="userLoading"
      :data="users"
      ref="userTable"
      border
      stripe
      style="width: 100%;">
      <el-table-column prop="oname" label="组织"></el-table-column>
      <el-table-column prop="orname" label="角色"></el-table-column>
      <el-table-column prop="mobile" label="手机号"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column label="操作" width="80">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleAddDoctor(scope.row)" v-if="!scope.row.isDoctor">添加</el-button>
          <el-button type="text" size="small" style="color: #FF4949;" @click="handleDeleteDoctor(scope.row)" v-else>删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleUserSizeChange" @current-change="handleUserCurrentChange" :current-page="userPagination.current" :page-sizes="userPagination.sizes" :page-size="userPagination.size" :layout="userPagination.layout" :total="userPagination.total"></el-pagination>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
